<div class="table-title card-header"
     [style.border-bottom-color]="state === 'collapsed' ? '$main-orange' : null">
  <div class=" table-header d-flex">
    <h4 class="table-title">
      <a>
        <i [ngClass]="state === 'collapsed' ? 'fa fa fa-arrow-down' : 'fa fa fa-arrow-up'" (click)="toggle()"></i>
      </a>
      {{ TABLE_TITLE }}
    </h4>
    <button type="button" class="btn btn-light" *ngIf="tableInfoExists" (click)="openInfoDialog()">
      <i class="fa fa-info-circle fa-sm"></i>
    </button>
  </div>
</div>

<div class="table-responsive"
     [@detailExpand]="state">
  <table class="table footable" data-breakpoints='{ "xs": 480, "sm": 768, "md": 992, "lg": 1200, "xl": 1400 }'
         matSort (matSortChange)="triggerSorting($event)">
    <thead class="thead-dark">
    <tr>
      <th mat-sort-header="{{header[0]}}" *ngFor="let header of TABLE_SORT_HEADERS">
        {{ header[1] }}
      </th>
      <th></th>
    </tr>
    </thead>

    <tbody>
    <tr *ngIf="loader.isActive()">
      <td colspan="12">
        <div class="loader-container">
          <app-loader></app-loader>
        </div>
      </td>
    </tr>

    <tr *ngIf="dataStatus.isFailed()">
      <td colspan="12">
        <div class="alert" role="alert" [ngClass]="dataStatus.errorCSS()">
          {{ dataStatus.errorMessage }}
        </div>
      </td>
    </tr>

    <tr *ngIf="dataStatus.thereIsInfo()">
      <td colspan="12">
        <div class="alert" role="alert" [ngClass]="dataStatus.infoCSS()">
          {{ dataStatus.infoMessage }}
        </div>
      </td>
    </tr>

    <ng-container *ngIf="dataStatus.isSuccesfully()">
      <tr *ngFor="let record of records">
        <td>
          <a [routerLink]="['/menu/scheda-certificato']" [queryParams]="{ isin: record.isin }">
            {{ record.isin ? record.isin : '--' }}
          </a>
        </td>
        <td>{{ record.nome ? record.nome : '--' }}</td>
        <td>{{ record.scadenza ? (record.scadenza | date:'dd/MM/yyyy') : '--' }}</td>
        <td>{{ record.demit ? record.demit : '--' }}</td>
        <td>{{ record.dmercato ? record.dmercato : '--' }}</td>
        <td *ngIf="record.dsott">
          <a [routerLink]="[ '/menu/sottostante']" [queryParams]="{ sottostante: record.dsott}">
            {{ record.dsott ? record.dsott : '--' }}
          </a>
        </td>
        <td *ngIf="!record.dsott">{{ '--' }}</td>
        <td>{{ record.totale ? record.totale : '--' }}</td>
        <td>{{ record.ask ? (record.ask | currency:currencySymbol(record.valuta):'symbol':'1.2-2':localeCurrency(record.valuta)) : '--' }}</td>
        <td>{{ record.importo ? (record.importo | currency:currencySymbol(record.valuta):'symbol':'1.2-2':localeCurrency(record.valuta)) : '--' }}</td>
        <td>{{ record.nextdate ? (record.nextdate | date:'dd/MM/yyyy') : '--' }}</td>
        <td [style.color]="record.datrigger < 0 ? 'red' : ''">
          {{ record.datrigger ? (record.datrigger | number:'1.0-2':'fr') : '--' }}%
        </td>

        <td>
            <a (click)="addIsinToWatchlist(record.isin)" matTooltip="Aggiungi isin ad una watchlist">
              <img [src]="'assets/images/icons/addToWatchlistGlassesSmall.png'" alt="Aggiungi alla watchlist" class="watchlistIcon">
            </a>
        </td>
      </tr>
    </ng-container>
    </tbody>

    <tfoot *ngIf="!loader.isActive()" class="footer-view-all">
    <tr>
      <td colspan="100%">
        <a class="nav-link" [routerLink]="[VIEW_ALL_PATH]">
          <i class="fa fa-plus"></i> Visualizza tutti
        </a>
      </td>
    </tr>
    </tfoot>
  </table>

</div>
